export default __webpack_public_path__ + "static/google-white-bf095ddc9243b96a67b9d9f88d77ba4c.png";